<template>
    <div>CHART OF ACCOUNTS SETUP</div>
</template>